export var isFileTypeImage = function isFileTypeImage(contentType) {
  switch (contentType) {
    case "image/jpeg":
    case "image/jpg":
    case "image/png":
    case "image/bmp":
    case "image/gif":
    case "image/svg+xml":
    case "image/apng":
    case "image/tiff":
      return true;

    default:
      return false;
  }
};